import useQuery from "@/Hooks/useQuery";
import { WarningIcon } from "@phosphor-icons/react/Warning";
import { Center } from "@freightsimple/ui-core/PageLayout/Center";
import { EmptyState } from "@freightsimple/ui-core/Display/EmptyState";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function ReferralScreen() {
  const query = useQuery();
  const navigate = useNavigate();

  const rawCode = query["code"];
  const referralCode = typeof rawCode === "string" ? rawCode : undefined;

  useEffect(
    function () {
      if (referralCode !== undefined && referralCode !== "") {
        localStorage.setItem("referralCode", referralCode);

        navigate("/create-account");
      }
    },

    [referralCode],
  );

  if (referralCode === undefined || referralCode === "") {
    return (
      <Center minHeight="calc(100vh - 200px)">
        <EmptyState icon={WarningIcon} title="Unknown Referral Code" />
      </Center>
    );
  }

  // We should have redirected
  return <></>;
}
